import React, { useEffect, useState } from 'react'
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter'
import { TableListBranches } from '../../components/TableBranchState';
import { useTranslation } from 'react-i18next';
import { generateCoincidentalDeliquencyByBranch } from '../../services/coincidentalDelinquency';
import { sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';
import { baseURL } from '../../services';
import { TableListBranches1 } from '../../components/TableListBranches1';

const ThirthyPlusPerDeliquency = () => {
    const { t } = useTranslation();

    
    
    const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => ({
        period: ["month"],
        fromDate: [sixMonthsAgoFormatted],
        toDate: [twoDaysAgoFormatted]
        }));

    const filters = [
        { key: "state", type: "select", label: t("filters.state") },
        // { key: "territory", type: "select", label: t("filters.territory") },
        { key: "cluster", type: "select", label: t("filters.cluster") },
        { key: "branch", type: "select", label: t("filters.branch") },
        { key: "period", type: "singleSelect", label: t("filters.period") },
        { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate },
        { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: twoDaysAgoFormatted },
      ];

    const [applyFilter, setApplyFilter] = useState<boolean>(false);
    const [orginationEwiByState, setOrginationEwiByState] = useState<any[]>([]);
    const [orginationEmiByState, setOrginationEmiByState] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [branchData, setBranchData] = useState<any[]>([]);
    const [branchData2, setBranchData2] = useState<any[]>([]);

    const [branchColumns, setBranchColumns] = useState<string[]>(["c_branch"]);
    
    
  //handle filter change
  const handleFilterChange = (updatedValues: Record<string, string[]>) => {
        setSelectedFilters(updatedValues);
    };
  //handle cancel click
    const handleCancelClick = () => {
        setSelectedFilters({
            period: ["month"],
            fromDate: [sixMonthsAgoFormatted],
            toDate: [twoDaysAgoFormatted]
        })
        setApplyFilter(!applyFilter)
    }


    //Download button API
      const handleDownloadClick = () => {   
        const link = `${baseURL}generate/portfolio_delinquency/list_coincidental_delinquency_by_branch_ewi_csv?from_date=${selectedFilters.fromDate ?? ""}&to_date=${selectedFilters.toDate ?? ""}&group_by=${selectedFilters.period ?? ""}&state_id=${selectedFilters.state ?? ""}&territory_id=${selectedFilters.territory ?? ""}&cluster_id=${selectedFilters.cluster ?? ""}&branch_id=${selectedFilters.branch ?? ""}`;
        window.location.href = link;
      }
//API to get  coincidental deliquency by branch
    const generatePortfolioNetMovement= async () => {
        setLoading(true);
        setBranchData([])
        setBranchData2([])
        setBranchColumns(["c_branch"])
        try {
          const response = await generateCoincidentalDeliquencyByBranch(selectedFilters); // Call the API function
          if (Array.isArray(response?.data)) {
            const periodDataArray = response.data;
      
            setBranchColumns(prevCols => {
              const newPeriods = periodDataArray
                .map((item: any) => item.period)
                // .filter((period: any) => !prevCols?.includes(period));
              return [...prevCols, ...newPeriods];
            });

      
            setBranchData(prevData => {
              const updatedData = [...prevData];
      
              periodDataArray.forEach((item: { period: string; branch_data: any[] }) => {
                const { period, branch_data } = item;
                branch_data.forEach((branch: any) => {
                    const bucket = branch.dpd_buckets?.find((b: any) => b.bucket_name === "%30+ DPD");
                    const count = bucket?.amount_percentage?.toString() ?? ""; // fallback to 0 if bucket missing
                
                    const existing = updatedData.find(b => b.c_branch === branch.branch_name);
                    if (existing) {
                      existing[period] = `${count} %`;
                    } else {
                      updatedData.push({
                        c_branch: branch.branch_name,
                        [period]: `${count} %`,
                      });
                    }
                  });
              });
      
              return updatedData;
            });

            setBranchData2(prevData => {
                const updatedData = [...prevData];
        
                periodDataArray.forEach((item: { period: string; branch_data: any[] }) => {
                  const { period, branch_data } = item;
                  branch_data.forEach((branch: any) => {
                      const bucket = branch.dpd_buckets?.find((b: any) => b.bucket_name === "%30+ DPD");
                      const count = bucket?.count_percentage?.toString() ?? ""; // fallback to 0 if bucket missing
                  
                      const existing = updatedData.find(b => b.c_branch === branch.branch_name);
                      if (existing) {
                        existing[period] = `${count} %`;
                      } else {
                        updatedData.push({
                          c_branch: branch.branch_name,
                          [period]: `${count} %`,
                        });
                      }
                    });
                });        
                return updatedData;
              });
          } else {
            setError("Unexpected response format.");
          }

        } catch (err) {
          setError("Failed to fetch users");
          console.error(err);
        } finally {
          setLoading(false);
        }
      };

    useEffect(() => {
        generatePortfolioNetMovement();
    }, [applyFilter]);

  return (
    <div>
        {/* Page Content */}
        <div className="page-content">
            {/* Dynamic Grey Header */}
            <div className="header">
            {t('coincidentalDeliquencyEWI.thirthyPlusPerDeliquency.pageTitle')}
            </div>

            <div className="content px-3">
                <MultiSelectCheckboxGroup 
                filters={filters} 
                selectedValues={selectedFilters} 
                onChange={handleFilterChange} 
                isLoading={[loading]}
                buttons={[
                    { label: t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter) },
                    { label: t("buttons.cancel"), onClick: handleCancelClick },
                    { label: t("buttons.download"), onClick: () => handleDownloadClick() },
                  ]}
                />
            </div>
            <div className="row justify-content-evenly">
                {/* <div className="col" style={{"overflow": "scroll", "width": "50%", "height": "60vh"}}>
                    <h1 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('coincidentalDeliquencyEWI.thirthyPlusPerDeliquency.%₹30+')}</h1>
                    <TableListBranches columns={branchColumns} data={branchData} />
                </div> */}

                <div
                            className="p-2 me-3"
                            style={{
                              maxWidth: "100%",
                              overflowX: "auto", // Prevent parent from contributing extra scrollbar
                            }}
                          >
                            <h2
                              style={{
                                fontSize: 15,
                                fontWeight: 600,
                                fontFamily: "Arial",
                                fontStyle: "normal",
                                textAlign: "start",
                                paddingLeft: "15px",
                                color: "#14213d",
                              }}
                            >
                              {t('coincidentalDeliquencyEWI.thirthyPlusPerDeliquency.%₹30+')}
                            </h2>
                
                            <div
                              style={{
                                
                                maxHeight: "60vh",
                                width: "100%",
                                
                              }}
                            >
                              <div style={{ minWidth: "fit-content" }}>
                                <TableListBranches1
                                  columns={branchColumns} data={branchData}
                                />
                              </div>
                            </div>
                          </div>
                {/* <div className="col" style={{"overflow": "scroll", "width": "50%", "height": "60vh"}}>
                    <h1 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('coincidentalDeliquencyEWI.thirthyPlusPerDeliquency.%#30+')}</h1>
                    <TableListBranches columns={branchColumns} data={branchData2} />
                </div> */}


<div
            className="p-2 me-3 mt-3"
            style={{
              maxWidth: "100%",
              overflowX: "auto", // Prevent parent from contributing extra scrollbar
            }}
          >
            <h2
              style={{
                fontSize: 15,
                fontWeight: 600,
                fontFamily: "Arial",
                fontStyle: "normal",
                textAlign: "start",
                paddingLeft: "15px",
                color: "#14213d",
              }}
            >
              {t('coincidentalDeliquencyEWI.thirthyPlusPerDeliquency.%#30+')}
            </h2>

            <div
              style={{
                
                maxHeight: "60vh",
                width: "100%",
               
              }}
            >
              <div style={{ minWidth: "fit-content" }}>
                <TableListBranches1
                  columns={branchColumns} data={branchData2}
                />
              </div>
            </div>
          </div>

            </div>

        </div>
    </div>
  )
}

export default ThirthyPlusPerDeliquency